import React, { useEffect } from 'react';
import axios from 'axios';
import { Layout } from '../components/layout/Layout';
import { Hero } from '../components/home/Hero';
import { Categories } from '../components/home/Categories';
import { Products } from '../components/home/Products';
import { TrustBadges, Offers } from '../components/home/Offers';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const HomePage = () => {
    // Seed data on first load
    useEffect(() => {
        const seedData = async () => {
            try {
                await axios.post(`${API}/seed`);
            } catch (error) {
                // Ignore if already seeded
            }
        };
        seedData();
    }, []);

    return (
        <Layout>
            <Hero />
            <Categories />
            <Products />
            <TrustBadges />
            <Offers />
        </Layout>
    );
};
